import React from 'react';
import {
  BodyTextContainer,
  Container,
  TitleTxt,
  TopBar,
} from './Objective1Styles';

// import IGEMLOGO from '../../../../../Img/mgemlogo.png';

export default function Objective1() {
  return (
    <div
      style={{
        height: 'max-content',
      }}
    >
      <Container>
        <TopBar src="https://static.igem.wiki/teams/4751/wiki/mgemlogo.png" />
        <div
          style={{
            justifyContent: 'end',
            display: 'flex',
          }}
        >
          <div
            style={{
              fontSize: '19px',
              fontWeight: 'bold',
              color: '#971A35',
              backgroundColor: '#efd2bf',
              padding: '20px 10px',
              width: '90%',
            }}
          >
            Objective #1: Developing a memory-based biological Sensing design
          </div>
        </div>
        <BodyTextContainer>
          <TitleTxt>
            CRISPR-mediated Recording to Encode Metabolite Concentration
          </TitleTxt>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '20px',
              marginTop: '20px',
            }}
          >
            <div
              style={{
                writingMode: 'vertical-lr',
                transform: 'rotate(180deg)',
                display: 'flex',
                justifyContent: 'end',
                padding: '15px',
                height: 'fit-content',
                fontSize: '20px',
                border: '2px solid #971A35',
              }}
            >
              HISTORY
            </div>
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              SCRIBE (Synthetic Cellular Recorders Integrating Biological
              Events), a strategy developed by Farzadfard and Lu (2014),
              generates intracellularly expressed single-stranded DNA (ssDNA) in
              response to various regulatory signals. The ssDNAs are recombined
              into genomic DNA at specific loci by coexpressed recombinases,
              resulting in precise point mutations which accumulate as a
              function of signal magnitude and duration. However, due to its
              limited recombination rate, SCRIBE requires actively dividing
              cells to achieve population-memory; the platform is more suitable
              for recording across collective genomes of cellular populations,
              rather than editing at the single-cell level (Farzadfard and Lu,
              2014).
              <br />
              <br />
              To overcome this dependence on large cell populations, Tang and
              Liu (2018) developed two CRISPR-mediated analog multi-event
              recording apparatus (CAMERA) systems, enabling analog recording
              within each cell. The systems use the CRISPR-Cas9 nuclease and
              Cas9-derived base editors, which are expressed on writing plasmids
              in response to stimuli of interest, to generate permanent DNA
              sequence modifications at guide RNA-specific loci on recording
              plasmids (Tang and Liu, 2018). Both systems achieved stable
              recording of the amplitude or duration of various signals; this
              can be extended to record multiple metabolite concentrations
              through assignment of associated mutations to unique locations on
              the plasmid. The ratio of edited to unedited DNA on these
              recording plasmids were shown to accurately record the duration
              and intensity of both chemical and light-based stimuli.
              <br />
              <br />
              The DNA-based Ordered Memory and Iteration Network Operator
              (DOMINO) is another genetic based recording platform that uses
              CRISPR base-editing technology to manipulate DNA in response to
              signals of interest (Farzadfard et al., 2019). By linking the
              guide RNA and the Cas9 complex to separate inducible promoters,
              the system can be controlled by an operational signal and another
              independent input, thereby forming a DOMINO operator that can only
              generate mutations when both inducers are present
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'end',
              }}
            >
              <div
                style={{
                  writingMode: 'vertical-lr',
                  padding: '15px',
                  fontSize: '20px',
                  border: '2px solid #971A35',
                  height: 'fit-content',
                }}
              >
                CAMERA & DOMINO
              </div>
            </div>
          </div>
          <br />
          <TitleTxt>Applicability to Ingestible Biosensor Design</TitleTxt>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '20px',
              marginTop: '20px',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                writingMode: 'vertical-lr',
                transform: 'rotate(180deg)',
                display: 'flex',
                justifyContent: 'end',
                padding: '15px',
                height: 'fit-content',
                fontSize: '20px',
                border: '2px solid #971A35',
              }}
            >
              BENEFITS
            </div>
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              The use of these genetic recording methods holds great potential
              for ingestible biosensing systems for several reasons. First,
              genetic readouts are more robust against temporal degradation;
              unlike fluorescent markers which have limited longevity due to
              protein degradation, base editing outputs remain constant for much
              longer (Corish and Tyler-Smith, 1999). Thus, the relationship
              between the initial stimulus intensity and output reading is not
              confounded by the time at which the output is measured. Second,
              CAMERA was shown to be functional across a range of conditions; it
              achieved recording multiple stimuli in both bacteria and mammalian
              cells, and maintained reliable readouts to multicopy plasmids in
              samples ranging from 10 to 100 cells (Tang and Liu, 2018).
              Therefore, base editing ratios remain stable after cell death and
              are passed down through bacterial generations.
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'end',
              }}
            >
              <div
                style={{
                  writingMode: 'vertical-lr',
                  padding: '15px',
                  fontSize: '20px',
                  height: 'fit-content',
                }}
              ></div>
            </div>
          </div>
          <br />
          <TitleTxt>Our Design</TitleTxt>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              marginTop: '20px',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              Based on this previous work, we propose a genetic reporter system with E coli. as the chassis (Figure 3). The system utilizes a second-generation base-editor (BE2) composed of a catalytically dead Cas9 protein (dCas9, which cannot cleave DNA) fused to a cytidine deaminase (CDA); Cas9 is directed to specific DNA targets, where CDA induces a CG to AT mutation. Together, they enable programmable editing of a specific base with no detectable off-target editing, and minimal formation of indel mutations (Komor et al., 2016; Tang and Liu, 2018; Luo et al., 2020).

            </div>
            <br />
            <img src="https://static.igem.wiki/teams/4751/wiki/new1.png" />
            <div
              style={{
                fontSize: '12px',
                width: '60%',
                textAlign: 'center',
                color: 'grey',
              }}
            >
              <b>Figure 3. Proposed biosensor system design for the molecular reading and recording of metabolites.</b><br />(A) An overview of the system as a whole
            </div>
            <br />
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              Our system design is based primarily on CAMERA 2.4 (Tang and Liu, 2018). The dCas9 relies on single guide RNA (sgRNA) to precisely target editing sites on specialized recording plasmids, which function only to record mutations (Komor et al., 2016). BE2 also includes a uracil-DNA glycosylase inhibitor (ugi) to potently block cellular repair machinery which may undo base editing (Farzadfard et al., 2019; Volke et al., 2022). The R1 recording plasmids from the CAMERA systems will be used in our design, along with BE2, sgRNA1, and sgRNA3 (Tang and Liu, 2018).  The expression of the two components for reading and recording will be linked to two separate promoters: 4-HPA will induce the expression of BE2 through the promoter PBC, while a metabolite of interest will induce the expression of sgRNA (Figure 3C). Once both BE2 and sgRNA have been produced, they will form a complex and initiate base editing at the target specified by the sgRNA sequence (Komor et al., 2016). Finally, PBC will also induce the expression of a separate sgRNA with a different base editing target site (sgRNA 1). The rationale for these design choices are explained in detail in the subsequent sections.
            </div>
            <br />
            <img src="https://static.igem.wiki/teams/4751/wiki/new2.png" />
            <br />
            <img src="https://static.igem.wiki/teams/4751/wiki/new3.png" />
            <br />
            <div
              style={{
                fontSize: '12px',
                width: '60%',
                textAlign: 'center',
                color: 'grey',
              }}
            >
              <b>Figure 3. Proposed biosensor system design for the molecular reading and recording of metabolites.</b><br />(B) the plasmid design for the 4-HPA promoter (PBC), metabolite promoter, and the constitutively active promoter which transcribes the individual metabolite receptor sensing systems, (C) a flowchart of important events: (1) 4-HPA induces the production of BE2 and sgRNA1 upon entry to the large intestine, and simultaneously, (2) the presence of a metabolite of interest induces the production of sgRNA3, then (3) the sgRNAs can dimerize with BE2 to (4) induce gene editing via point mutations.
            </div>
            <br />
          </div>
          <br />
          <TitleTxt>Specific Large Intestine Testing</TitleTxt>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              marginTop: '20px',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              4-hydroxyphenylacetate, also known as 4-HPA, was identified as a compound with high specificity to the large intestine (Meier et al., 2023). As an amino acid degradation product, metabolic profiling of male mouse gut samples shows that 4-HPA undergoes extensive microbial fermentation, leading to sharp increases in concentration from the small intestine to the large intestine: in 5 male mice with healthy gut microbiota, 4-HPA demonstrated 22.8x higher concentrations in the large intestine lumen compare to the small intestine (p = 0.0018). From the ileum to the colon, concentrations of 4-HPA increase from close to 0 M to around 0.10 mM (Meier et al., 2023). Thus, the utilization of 4-HPA as an inducer allows our proposed sensing system to be specific to the large intestine.
            </div>
            <br />
            <img src="https://static.igem.wiki/teams/4751/wiki/hpax.png"/>
            <div
              style={{
                fontSize: '12px',
                width: '60%',
                textAlign: 'center',
                color: 'grey',
              }}
            >
              <b>Figure 4. </b><br />Schematic depicting the 4-HPA sensing system.
            </div>
            <br />
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              Based on 4-HPA bioassays constructed by Dierckx et al. (2015), 4-HPA can be sensed using the following system that is part of a catabolic pathway in E. coli: HpaX transports 4-HPA into the bacteria, 4-HPA then binds to transcription factor HpaA, which causes a conformational change that allows HpAa to bind to PBC to promote the expression of downstream genes (Figure 4). The hpaA gene, which encodes for HpaA, as well as hpaX, which encodes for the transporter, are constitutively expressed (Jilin China, 2019). In addition, this sensing system does not share any elements with the detection systems used for our selected metabolites of interest. 
            </div>
            <br />
          </div>

          <TitleTxt>Metabolite Sensing with sgRNA</TitleTxt>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              marginTop: '20px',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              The aforementioned 4-HPA sensing system enables targeted sensing of metabolites in the large intestine due to the specificity of 4-HPA and its independence from the promoter systems used to achieve sensing of the proposed metabolites of interest. To achieve this, we propose for the expression of BE2 to be induced by 4-HPA-mediated activation of PBC, while the sgRNA will be induced by the metabolite of interest. To minimize metabolic burden on the host cells, the constitutive promoter regulating HpaA expression will be of high strength, while the constitutive promoters regulating the individual metabolite sensing systems (H2O2 and tetrathionate specifically) will be of low strength. By linking the expression of each component to a separate promoter, AND-gate functionality can be achieved; base editing requires the activation of both promoters, which will only occur within the large intestine. Based on this design, the presence of any metabolites of interest in other gut regions will not initiate base editing, as BE2 will only be produced while the biosensor is within the large intestine. 
            </div>
            <br />
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              It should be noted that this system design could feasibly allow for the simultaneous detection of multiple metabolites within a single bacterium by linking each metabolite to a separate sgRNA, and as such, a distinct base editing site (Tang and Liu, 2018). We have elected to restrict our design to include one metabolite per bacterium for two primary reasons: 1) it minimizes competition that would arise from having many different sgRNAs simultaneously compete for available BE2 (Tang and Liu, 2018), and 2) it ensures that there is sufficient space on the write plasmid to encode both the sensing and editing system, especially for large multi-component sensing systems. To quantify multiple metabolites, a separate bacterial strain can be used containing its respective plasmid.
            </div>
            <br />
            <div
              style={{
                fontSize: '14px',
                width: '60%',
              }}
            >
              It is important to note that since recording is dependent on both BE2, which is regulated by 4-HPA, and sgRNA, which is regulated by metabolite concentrations, the final base-editing ratio can be confounded by variations in 4-HPA concentration. Given the situation where a metabolite of interest is assessed in an individual and found to be identical at two different time points, if 4-HPA levels are not accounted for, the erroneous conclusion that metabolite levels have changed would be made. Hence, in order for meaningful concentration data to be extracted from base editing ratios, any variance in the induction of the 4-HPA promoter relating to concentration must be corrected as a factor. To address this, an additional sgRNA will be linked to the 4-HPA-sensing promoter (PBC) with a distinct editing target separate from the metabolite-associated sgRNA. Specifically, sgRNA1 will be used to direct base editing at position 166 on the recording plasmids (Tang and Liu, 2018). sgRNA3 will be linked to the metabolites of interest, and will direct base editing at position 186 on the recording plasmids (Tang and Liu, 2018). The editing ratios at two distinct locations enable direct quantification of the amplitude of 4-HPA exposure. Using this information, base editing ratios can be scaled in a way that reduces this effect (see Normalization Model).
            </div>
            <br />
          </div>
        </BodyTextContainer>
      </Container>
    </div>
  );
}
